module.exports = __webpack_public_path__ + "static/media/icon-medium.74df09ee.svg";